<template>
    <div v-if="className == 'sub-tab-wrap'" :class="className">
        <template v-for="item in gnbs">
            <ul class="tab tab--block" :key="item.title" v-if="item.title == sh">
                <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{ active: tabActive == child.title }">
                    <a :href="child.path" class="tab__btn">
                        <span class="word-keep-all">
                            <template v-if="child?.title == '연구개발 및 교육사업'">
                                연구개발 <br />
                                및 교육사업
                            </template>
                            <template v-else>
                                {{ child.title }}
                            </template>
                        </span>
                    </a>
                </li>
            </ul>
        </template>
    </div>
    <ul v-else-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <template v-if="item.hide !== true">
                <li v-if="!item.group1 && !item.group2 && !item.group3 && !item.group4" :class="className + '__li'" :key="item.title">
                    <router-link :to="item.path" :class="className + '__link'"
                        ><h2>{{ item.title }}</h2></router-link
                    >
                </li>

                <template v-else>
                    <v-hover v-slot="{ hover }" :key="item.title" transition="fade-transition">
                        <li :class="className + '__li'" class="d-none d-xl-block">
                            <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                                <h2>{{ item.title }}</h2>
                            </div>
                            <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'">
                                <h2>
                                    {{ item.title }}
                                </h2>
                            </router-link>

                            <template v-if="hover">
                                <v-fade-transition>
                                    <v-card tile flat width="100%" class="new-sub">
                                        <v-row class="row--sm">
                                            <v-col cols="3">
                                                <router-link :to="item.path" class="font-weight-bold font-size-20">
                                                    {{ item.title }}
                                                </router-link>
                                            </v-col>
                                            <v-col>
                                                <v-row>
                                                    <v-col v-if="item.group1" cols="3">
                                                        <v-row class="row--sm">
                                                            <v-col v-for="child in item.group1" :key="child.title" cols="12">
                                                                <router-link :to="child.path" class="font-weight-medium">
                                                                    {{ child.title }}
                                                                </router-link>
                                                                <v-row v-if="child.children" class="row--xxs pt-16 grey-6--text">
                                                                    <v-col v-for="grandChild in child.children" :key="grandChild.title" cols="12">
                                                                        <router-link :to="grandChild.path">
                                                                            {{ grandChild.title }}
                                                                        </router-link>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col v-if="item.group2" cols="3">
                                                        <v-row class="row--sm">
                                                            <v-col v-for="child in item.group2" :key="child.title" cols="12">
                                                                <router-link :to="child.path" class="font-weight-medium">
                                                                    {{ child.title }}
                                                                </router-link>
                                                                <v-row v-if="child.children" class="row--xxs pt-16 grey-6--text">
                                                                    <v-col v-for="grandChild in child.children" :key="grandChild.title" cols="12">
                                                                        <router-link :to="grandChild.path">
                                                                            {{ grandChild.title }}
                                                                        </router-link>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col v-if="item.group3" cols="3">
                                                        <v-row class="row--sm">
                                                            <v-col v-for="child in item.group3" :key="child.title" cols="12">
                                                                <router-link :to="child.path" class="font-weight-medium">
                                                                    {{ child.title }}
                                                                </router-link>
                                                                <v-row v-if="child.children" class="row--xxs pt-16 grey-6--text">
                                                                    <v-col v-for="grandChild in child.children" :key="grandChild.title" cols="12">
                                                                        <router-link :to="grandChild.path">
                                                                            {{ grandChild.title }}
                                                                        </router-link>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col v-if="item.group4" cols="3">
                                                        <v-row class="row--sm">
                                                            <v-col v-for="child in item.group4" :key="child.title" cols="12">
                                                                <router-link :to="child.path" class="font-weight-medium">
                                                                    {{ child.title }}
                                                                </router-link>
                                                                <v-row v-if="child.children" class="row--xxs pt-16 grey-6--text">
                                                                    <v-col v-for="grandChild in child.children" :key="grandChild.title" cols="12">
                                                                        <router-link :to="grandChild.path">
                                                                            {{ grandChild.title }}
                                                                        </router-link>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                        <div class="new-sub__bg" />
                                    </v-card>
                                    <!-- <ul :class="className + '__sub'">
                                        <li v-for="child in item.children" :key="child.title">
                                            <router-link :to="child.path">{{ child.title }}</router-link>
                                        </li>
                                    </ul> -->
                                </v-fade-transition>
                            </template>
                        </li>
                    </v-hover>
                </template>
            </template>
        </template>
    </ul>

    <v-list v-else class="d-xl-none mobile-list">
        <template v-for="(item, index) in gnbs">
            <template v-if="item.hide !== true">
                <v-list-item v-if="!item.group1 && !item.group2 && !item.group3 && !item.group4" :key="index">
                    {{ item.title }}
                </v-list-item>
                <v-list-group v-else :key="index">
                    <template #activator>
                        <v-list-item-title>
                            {{ item.title }}
                        </v-list-item-title>
                    </template>
                    <template v-if="item.group1">
                        <template v-for="(child, index) in item.group1">
                            <template v-if="child.children">
                                <v-list-group :key="index" sub-group>
                                    <template #activator>
                                        <v-list-item-title>
                                            {{ child.title }}
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(grandChild, index) in child.children" :key="index" :to="grandChild.path">
                                        {{ grandChild.title }}
                                    </v-list-item>
                                </v-list-group>
                            </template>
                            <template v-else>
                                <v-list-item :key="index" :to="child.path">
                                    {{ child.title }}
                                </v-list-item>
                            </template>
                        </template>
                    </template>
                    <template v-if="item.group2">
                        <template v-for="(child, index) in item.group2">
                            <template v-if="child.children">
                                <v-list-group :key="index" sub-group>
                                    <template #activator>
                                        <v-list-item-title>
                                            {{ child.title }}
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(grandChild, index) in child.children" :key="index" :to="grandChild.path">
                                        {{ grandChild.title }}
                                    </v-list-item>
                                </v-list-group>
                            </template>
                            <template v-else>
                                <v-list-item :key="index" :to="child.path">
                                    {{ child.title }}
                                </v-list-item>
                            </template>
                        </template>
                    </template>
                    <template v-if="item.group3">
                        <template v-for="(child, index) in item.group3">
                            <template v-if="child.children">
                                <v-list-group :key="index" sub-group>
                                    <template #activator>
                                        <v-list-item-title>
                                            {{ child.title }}
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(grandChild, index) in child.children" :key="index" :to="grandChild.path">
                                        {{ grandChild.title }}
                                    </v-list-item>
                                </v-list-group>
                            </template>
                            <template v-else>
                                <v-list-item :key="index" :to="child.path">
                                    {{ child.title }}
                                </v-list-item>
                            </template>
                        </template>
                    </template>
                    <template v-if="item.group4">
                        <template v-for="(child, index) in item.group4">
                            <template v-if="child.children">
                                <v-list-group :key="index" sub-group>
                                    <template #activator>
                                        <v-list-item-title>
                                            {{ child.title }}
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item v-for="(grandChild, index) in child.children" :key="index" :to="grandChild.path">
                                        <v-list-item-title>
                                            {{ grandChild.title }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                            </template>
                            <template v-else>
                                <v-list-item :key="index" :to="child.path">
                                    {{ child.title }}
                                </v-list-item>
                            </template>
                        </template>
                    </template>
                </v-list-group>
            </template>
        </template>
    </v-list>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
        sh: String,
        tabActive: String,
    },
    data: function () {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "후원안내",
                    path: "/guide/regular",
                    group1: [
                        {
                            title: "정기후원",
                            path: "/guide/regular",
                        },
                        {
                            title: "일시후원",
                            path: "/guide/temporary",
                        },
                        {
                            title: "결연후원",
                            path: "/guide/domestic",
                            children: [
                                {
                                    title: "국내아동결연",
                                    path: "/guide/domestic",
                                },
                                {
                                    title: "해외아동결연",
                                    path: "/guide/overseas",
                                },
                            ],
                        },
                    ],
                    group2: [
                        {
                            title: "캠페인 후원",
                            path: "/news/campaign",
                            children: [
                                {
                                    title: "진행중인 캠페인",
                                    path: "/news/campaign",
                                },
                                {
                                    title: "완료된 캠페인",
                                    path: "/news/campaign/ended",
                                },
                            ],
                        },
                    ],
                    group3: [
                        {
                            title: "기업후원",
                            path: "/guide/company",
                        },
                        {
                            title: "물품후원",
                            path: "/guide/goods",
                        },
                    ],
                    group4: [
                        {
                            title: "유산기부",
                            path: "/guide/legacy",
                        },
                        {
                            title: "위드캔 아너스클럽",
                            path: "/guide/honors",
                        },
                    ],
                },
                {
                    title: "사업",
                    path: "/business/domestic/care",
                    group1: [
                        {
                            title: "국내사업",
                            path: "/business/domestic/care",
                            children: [
                                {
                                    title: "아동돌봄사업",
                                    path: "/business/domestic/care",
                                },
                                {
                                    title: "아동권리옹호사업",
                                    path: "/business/domestic/rights",
                                },
                                {
                                    title: "중노년동행사업",
                                    path: "/business/domestic/middle",
                                },
                                {
                                    title: "일자리 창출사업",
                                    path: "/business/domestic/job",
                                },
                                {
                                    title: "지역사회복지사업",
                                    path: "/business/domestic/community",
                                },
                                {
                                    title: "연구개발 및 교육사업",
                                    path: "/business/domestic/research",
                                },
                            ],
                        },
                    ],
                    group2: [
                        {
                            title: "해외사업",
                            path: "/business/overseas/aid",
                            children: [
                                {
                                    title: "인도적 지원사업",
                                    path: "/business/overseas/aid",
                                },
                                {
                                    title: "지역개발사업",
                                    path: "/business/overseas/region",
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "국내복지사업",
                    path: "/business/domestic/care",
                    hide: true,
                    children: [
                        {
                            title: "아동돌봄사업",
                            path: "/business/domestic/care",
                        },
                        {
                            title: "아동권리옹호사업",
                            path: "/business/domestic/rights",
                        },
                        {
                            title: "중노년동행사업",
                            path: "/business/domestic/middle",
                        },
                        {
                            title: "일자리 창출사업",
                            path: "/business/domestic/job",
                        },
                        {
                            title: "지역사회복지사업",
                            path: "/business/domestic/community",
                        },
                        {
                            title: "연구개발 및 교육사업",
                            path: "/business/domestic/research",
                        },
                    ],
                },
                {
                    title: "해외사업",
                    path: "/business/overseas/aid",
                    hide: true,
                    children: [
                        {
                            title: "인도적 지원사업",
                            path: "/business/overseas/aid",
                        },
                        {
                            title: "지역개발사업",
                            path: "/business/overseas/region",
                        },
                    ],
                },
                {
                    title: "재단소개",
                    path: "/about",
                    group1: [
                        {
                            title: "위드캔복지재단",
                            path: "/about",
                        },
                        {
                            title: "인사말",
                            path: "/about/greeting",
                        },
                        {
                            title: "조직현황",
                            path: "/about/organization",
                            children: [
                                {
                                    title: "사회복지법인",
                                    path: "/about/organization",
                                },
                                {
                                    title: "국내사업기관",
                                    path: "/about/organization/domestic",
                                },
                            ],
                        },
                        {
                            title: "연혁",
                            path: "/about/history",
                        },
                    ],
                    group2: [
                        {
                            title: "함께하는 사람들",
                            path: "/about/people",
                            children: [
                                {
                                    title: "함께하는 후원회",
                                    path: "/about/people#association",
                                },
                                {
                                    title: "위드캔 엠버서더",
                                    path: "/about/people#ambassador",
                                },
                                {
                                    title: "후원사",
                                    path: "/about/people#corporate",
                                },
                            ],
                        },
                        {
                            title: "투명경영",
                            path: "/about/management",
                        },
                        {
                            title: "공시자료",
                            path: "/about/board?code=notice",
                        },
                    ],
                    group3: [
                        {
                            title: "오시는 길",
                            path: "/about/location",
                        },
                    ],
                },
                // {
                //     title: "법인소개",
                //     path: "/company/intro",
                //     children: [
                //         {
                //             title: "위드 캔 소개",
                //             path: "/company/intro",
                //         },
                //         {
                //             title: "나눔기업",
                //             path: "/company/partner",
                //         },
                //     ],
                // },
                // {
                //     title : "후원하기",
                //     path : "/support/regular",
                //     children : [
                //         {
                //             title : "정기후원",
                //             path : "/support/regular",
                //         },
                //         {
                //             title : "일시후원",
                //             path : "/support/temporary",
                //         },
                //         {
                //             title : "결연후원",
                //             path : "/support/relationship",
                //         },
                //         // {
                //         //     title : "해외결제",
                //         //     path : "/support/foreign",
                //         // },
                //         // {
                //         //     title : "기업후원",
                //         //     path : "/support/corporation",
                //         // },
                //         // {
                //         //     title : "물품후원",
                //         //     path : "/support/commodity",
                //         // },
                //         {
                //             title : "유산기부",
                //             path : "/support/legacy",
                //         },
                //         {
                //             title : "후원 가이드",
                //             path : "/support/guide",
                //         },
                //     ]
                // },
                // {
                //     title: "캠페인",
                //     // path: "/campaign/campaign?code=koCampaign",
                //     path: "/campaign/campaign",
                //     children: [
                //         {
                //             title: "캠페인",
                //             // path: "/campaign/campaign?code=koCampaign",
                //             path: "/campaign/campaign",
                //         },
                //         {
                //             title: "캠페인 그 후",
                //             path: "/campaign/after",
                //         },
                //         // {
                //         //     title : "비대면 봉사활동 (단체)",
                //         //     path : "/campaign/group",
                //         // },
                //     ],
                // },
                {
                    title: "소식",
                    path: "/board/notice",
                    group1: [
                        {
                            title: "공지사항",
                            path: "/board/notice",
                            children: [
                                {
                                    title: "일반공지",
                                    path: "/board/notice/general",
                                },
                                {
                                    title: "인재채용",
                                    path: "/board/notice/recruitment",
                                },
                            ],
                        },
                    ],
                    group2: [
                        {
                            title: "언론보도",
                            path: "/board/report",
                        },
                    ],
                    group3: [
                        {
                            title: "위드캔 스토리",
                            path: "/board/story",
                            children: [
                                {
                                    title: "재단소식",
                                    path: "/board/story/newsletter",
                                },
                                {
                                    title: "후원자 소식",
                                    path: "/board/story/supporter",
                                },
                                {
                                    title: "사업기관 소식",
                                    path: "/board/story/news",
                                },
                            ],
                        },
                    ],
                    group4: [
                        {
                            title: "발간 자료실",
                            path: "/board/library",
                        },
                    ],
                },
                // {
                //     title: "소통과 참여",
                //     path: "/community/board?code=notice",
                //     children: [
                //         {
                //             title: "공지사항",
                //             path: "/community/board?code=notice",
                //         },
                //         {
                //             title: "보도자료",
                //             path: "/community/board?code=report",
                //         },
                //         {
                //             title: "재단소식",
                //             path: "/community/board?code=newsletter",
                //         },
                //         {
                //             title: "산하시설소식",
                //             path: "/community/news",
                //         },
                //         // {
                //         //     title : "소식지",
                //         //     path : "/community/board?code=news",
                //         // },
                //         {
                //             title: "인재채용",
                //             path: "/community/board?code=reference",
                //         },
                //         {
                //             title: "자주묻는 질문",
                //             path: "/community/faqs",
                //         },
                //         // {
                //         //     title : "자원봉사",
                //         //     path : "/community/board?code=volunteer",
                //         // },
                //         // {
                //         //     title : "이벤트",
                //         //     path : "/community/board?code=event",
                //         // },

                //         // {
                //         //     title : "위드 캔 소식받기",
                //         //     path : "/support/news",
                //         // },
                //     ],
                // },
            ],
        };
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1200;
        },
        isMobile: function () {
            return this.window.width < 1200;
        },
    },
    created: function () {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function () {},
    methods: {
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>

<style lang="scss" scoped>
.gnb__link {
    justify-content: center;
}
.new-sub {
    position: absolute;
    left: 0;
    z-index: 100;
    padding: 40px 0;
    &__bg {
        position: absolute;
        width: 200vw;
        left: -50vw;
        top: 0;
        height: 100%;
        background-color: #fff;
        z-index: -1;
    }
}
.mobile-list {
    padding: 0;
    > .v-list-group {
        > ::v-deep(.v-list-group__header) {
            padding: 10px 0;
            min-height: initial;
            > .v-list-item__title {
                font-size: 18px;
                font-weight: 700;
            }
        }
    }
    ::v-deep(.v-list-group--sub-group) {
        > .v-list-group__header {
            padding: 0 16px !important;
            > .v-list-item__icon {
                order: 2;
                margin-right: 0;
                margin-left: 16px;
            }
        }
    }
}
</style>